// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"121":"gallery","443":"about","511":"cart","566":"catering","637":"order"}[chunkId] || chunkId) + "." + {"121":"8002bf59","443":"fdfb20a1","511":"6d4360d4","566":"c49f3cc0","637":"46cd0990","720":"9120f2fa"}[chunkId] + ".css";
};